import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './ModuloMenu.sass';
import { mapearUrlModulo } from '../../../utils';

export default class ModuloMenu extends Component {

    render() {
        const { nome, sigla } = this.props;
        const urlMapeada = mapearUrlModulo(this.props.url);

        return (
                <a href={urlMapeada + '?accessToken=' + this.props.tokenModulo} style={{ textDecoration: 'none' }}>
                    <div className="menu-container">
                        <div className="mini-container">
                            <span className="sigla">{sigla}</span>
                        </div>
                        <span className="label">{nome}</span>
                    </div>
                </a>
        );
    }
}

ModuloMenu.propTypes = {
    nome: PropTypes.string,
    sigla: PropTypes.string,
    url: PropTypes.string,
    tokenModulo: PropTypes.string
}